<template>
	<div :id="id" :monitorData="monitorData" style=" width: 100%;height: 100%; padding:0 10px; box-sizing: border-box;">
		这是监控折线图
	</div>
</template>

<script>
	//引入基本模板
	let echarts = require('echarts/lib/echarts')
	//引入折线图
	require('echarts/lib/chart/line')
	//引入提示框和title组件
	require('echarts/lib/component/tooltip')
	require('echarts/lib/component/title')
	require('echarts/lib/component/graphic')
	require('echarts/lib/component/legend')
	require('echarts/lib/component/markPoint.js')
	export default{
		name:'WcMonitorChart',
		props:['id','monitorData'],
		data(){
			return{
				
			}
		},
		methods:{
			drawLine(){
				let myChart = echarts.init(document.getElementById(this.id));				
				myChart.setOption({
					color:['#50A960'],
					tooltip : {
     	                trigger: 'axis',
     	                formatter: function(params){
     	                	var returnValue;
     	                	let powerPattern = /^电源((\d+\.)*\d+)状态/;
							let fanPattern = /^风扇((\d+\.)*\d+)状态/;
							var transferValue=params[0].value;
							var seriesName=params[0].seriesName;
							if(seriesName.indexOf("(")>0){
								seriesName=seriesName.substr(0,seriesName.indexOf("("));
							}
							if(powerPattern.test(params[0].seriesName) || fanPattern.test(params[0].seriesName)){
								switch(params[0].value){
									case 1:
										transferValue="正常";
										break;
									case 2:
										transferValue="不正常";
										break;
									case 3:
										transferValue="未插入";
										break;
									case 4:
										transferValue="不支持";
										break;
								}
							}
     	                	returnValue = params[0].name + "</br>" + seriesName + ":" 
     	                	+ transferValue;
     	                	return returnValue;
     	                }
     	            },
					legend:{
						show:false
					},
					/* grid:{
						x:40,
						y:10,
						x2:20,
						y2:30
					}, */
					calculable:true,
					xAxis:[{
						type:'category',
						boundaryGap:false,
						axisLine:{
							lineStyle:{
								color:'#95CCEB',
								width:1,
								type:'solid',
							}
						},
						axisLabel:{
							textStyle:{
								color:'#9c9c9c',
								fontSize:8
							}
						},
						data:this.monitorData.dataTime,
					}],
					yAxis:[{
						type:'value',
						splitLine:{
							show:true,
							lineStyle:{
								color:'#B0E6F5',
								width:1,
								type:'dashed'
							}
						},
						axisLine:{
							lineStyle:{
								color:'#95CCEB',
								width:1,
								type:'solid'
							}
						},
						axisLabel:{
							textStyle:{
								color:'#2c9ad7',
								fontSize:8
							},
						}
					}],
					grid:{
						top:40,
						bottom:40,
					},
					series:[{
						name:this.monitorData.name,
						type:'line',
						data:this.monitorData.value,
						smooth:false,
						lineStyle:{
							normal:{
								width:1
							}
						},
						itemStyle:{
							normal:{
								color:'#3ab782',
								areaStyle:{
									type:'default'
								}
							}
						},
						areaStyle:{
							normal:{
								color:new echarts.graphic.LinearGradient(0,0,0,1,[{
									offset:0,
									color:'rgb(134,234,193)'
								},{
									offset:1,
									color:'rgb(255,255,255)'
								}])
							}
						},
						markPoint:{
							symbol:'roundRect',
							symbolSize:[30,20],
							symbolOffset :['0','-13'],
							label:{
								fontSize:8,
							},
							data:[{
								type:'max',
								name:'最大值'
							},{
								type:'min',
								name:'最小值'
							}]
						}
					}]
					
				})
			}
		},
		mounted:function(){
			this.drawLine();
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/monitor/monitorChart/WcMonitorChart.vue